import React from 'react';
import { Helmet } from 'react-helmet-async';

export const PWAManifest: React.FC = () => {
  const manifest = {
    name: 'Disney Magic Community',
    short_name: 'Disney Magic',
    description: 'Share your Disney adventures and connect with fellow Disney enthusiasts',
    start_url: '/',
    display: 'standalone',
    theme_color: '#7C3AED',
    background_color: '#F0F2F5',
    orientation: 'portrait-primary',
    scope: '/',
    categories: ['social', 'entertainment', 'lifestyle'],
    lang: 'en',
    icons: [
      {
        src: '/favicon.ico',
        sizes: '64x64 32x32 24x24 16x16',
        type: 'image/x-icon'
      },
      {
        src: '/icon-192.png',
        type: 'image/png',
        sizes: '192x192',
        purpose: 'maskable'
      },
      {
        src: '/icon-512.png',
        type: 'image/png',
        sizes: '512x512',
        purpose: 'maskable'
      }
    ],
    shortcuts: [
      {
        name: 'Feed',
        short_name: 'Feed',
        description: 'View latest Disney posts',
        url: '/feed',
        icons: [{ src: '/icon-192.png', sizes: '192x192' }]
      },
      {
        name: 'Photos',
        short_name: 'Photos',
        description: 'Browse Disney photos',
        url: '/photographers',
        icons: [{ src: '/icon-192.png', sizes: '192x192' }]
      },
      {
        name: 'Tips',
        short_name: 'Tips',
        description: 'Disney tips and tricks',
        url: '/tips',
        icons: [{ src: '/icon-192.png', sizes: '192x192' }]
      }
    ]
  };

  return (
    <Helmet>
      <link rel="manifest" href={`data:application/json,${encodeURIComponent(JSON.stringify(manifest))}`} />
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="application-name" content="Disney Magic" />
      <meta name="apple-mobile-web-app-title" content="Disney Magic" />
      <meta name="msapplication-starturl" content="/" />
      <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no, viewport-fit=cover" />
      <meta name="theme-color" content="#7C3AED" />
      <meta name="apple-mobile-web-app-status-bar-style" content="default" />
      <meta name="format-detection" content="telephone=no" />
      <meta name="mobile-web-optimized" content="width" />
      <meta name="HandheldFriendly" content="true" />
    </Helmet>
  );
};